export type EnumSort = keyof typeof SORT;

export enum SORT {
  NEWEST = 'NEWEST',
  OLDEST = 'OLDEST',
  POPULAR = 'POPULAR'
}
